export enum NotificationEventTypes {
  FooBar = 'foo_bar',
  FooBaz = 'foo_baz',
}
